import React from 'react';
import { Redirect } from 'react-router-dom';
import pathToRegexp from 'path-to-regexp';

/**
 * <Redirect> with status code
 * @see {@link https://reacttraining.com/react-router/web/guides/server-rendering}
 *
 * @param {string} to - Express-style path
 * @param {301|302} status - redirect HTTP status code
 */
export default function redirectWithStatus(to, status) {
  return function RedirectWithStatus(props) {
    const {
      staticContext,
      location: { search },
      match: { params },
    } = props;

    if (staticContext) {
      staticContext.status = /30(1|2)/.test(status) ? status : 302;
    }

    const pathname = pathToRegexp.compile(to)(params);

    return (
      <Redirect
        to={{
          pathname,
          search,
        }}
      />
    );
  };
}
